import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import Layout from '../components/Layout';
import FleetSlider from '../components/FleetSlider';
import { useApp, resolveImg } from '../context/AppContext';
import { fleetSection } from '../mock/content';
import { currencySymbols, rates } from '../mock/mock';
import useSEO from '../hooks/useSEO';

const FleetPage = () => {
  const { lang, currency, vehicles } = useApp();
  const s = fleetSection[lang] || fleetSection.en;
  const fmt = (n) => `${currencySymbols[currency]} ${Math.round(n * rates[currency])}`;
  const seo = {
    de: 'Fahrzeugflotte | CAB.TAXI Zürich',
    en: 'Vehicle Fleet | CAB.TAXI Zurich',
    fr: 'Flotte de véhicules | CAB.TAXI Zurich',
    it: 'Flotta veicoli | CAB.TAXI Zurigo',
  }[lang];
  useSEO(seo, s.subtitle);

  return (
    <Layout>
      <section className="py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-10">
            <h1 className="text-4xl font-extrabold text-[color:var(--brand-dark)]">{s.title}</h1>
            <p className="mt-4 text-gray-500 leading-relaxed">{s.subtitle}</p>
          </div>
          <FleetSlider />
        </div>
      </section>

      <section className="py-14 bg-[color:var(--brand-muted)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 space-y-6">
          {vehicles.map((v, i) => {
            return (
              <div key={v.id} className={`bg-white rounded-2xl overflow-hidden flex flex-col md:flex-row ${i % 2 ? 'md:flex-row-reverse' : ''} shadow-sm`}>
                <img src={resolveImg(v.img)} alt={v.name} className="md:w-1/2 h-60 md:h-72 object-cover" />
                <div className="p-7 md:w-1/2 flex flex-col justify-center">
                  <h2 className="text-2xl font-extrabold text-[color:var(--brand-dark)]">{v.name}</h2>
                  <p className="mt-3 text-gray-500 leading-relaxed">{v.model}</p>
                  <ul className="mt-4 space-y-2 text-sm text-[color:var(--brand-dark)]">
                    <li className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4" style={{ color: 'var(--brand-accent)' }} /> {v.pax} {lang === 'de' ? 'Passagiere' : lang === 'fr' ? 'passagers' : lang === 'it' ? 'passeggeri' : 'passengers'}</li>
                    <li className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4" style={{ color: 'var(--brand-accent)' }} /> {v.bags} {lang === 'de' ? 'Gepäckstücke' : lang === 'fr' ? 'bagages' : lang === 'it' ? 'bagagli' : 'bags'}</li>
                    <li className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4" style={{ color: 'var(--brand-accent)' }} /> {lang === 'de' ? 'Festpreis inkl. Wartezeit' : lang === 'fr' ? 'Prix fixe, attente incluse' : lang === 'it' ? 'Prezzo fisso, attesa inclusa' : 'Fixed price incl. waiting'}</li>
                  </ul>
                  <div className="mt-5 flex items-center gap-4">
                    <span className="text-sm text-gray-400">{s.from} <b className="text-[color:var(--brand-dark)] text-lg">{fmt(90 * v.priceFactor)}</b></span>
                    <a href="/#book" className="accent-btn rounded-full px-5 py-2.5 text-sm font-bold">{s.book}</a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </Layout>
  );
};

export default FleetPage;
